import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BirdIdLogo',
  props: {
  width: { default: 252 },
  height: { default: 72 }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})